import React from 'react';

/**
 * @class SignUpHeader
 */
const SignUpHeader = () => (
  <div>
    <p id="callId">
             Call (
      {' '}
      <span id="phoneId"> +234 813 2685 000 </span>
      {' '}
                )
      {' '}
      <small> or </small>
      {' '}
      <span id="phoneId"> Email us </span>
    </p>
  </div>
);

export default SignUpHeader;
